import { render, staticRenderFns } from "./HtmlSplitEditor.vue?vue&type=template&id=01096554&scoped=true&"
import script from "./HtmlSplitEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlSplitEditor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlSplitEditor.vue?vue&type=style&index=0&id=01096554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01096554",
  null
  
)

export default component.exports